import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Pagination from 'react-bootstrap/Pagination'
import { generatePath } from 'react-router-dom'
import { SearchPaginationProps } from './types'

const SearchPagination = (props: SearchPaginationProps) => {
    const { page, limit, pages, link } = props
    const [selectedPage, setSelectedPage] = useState<number>(page)

    const makeLink = useCallback(
        (pageId: number) => {
            return generatePath(link, {
                limit: limit.toString(),
                page: pageId.toString(),
            })
        },
        [link, limit, selectedPage],
    )

    const pagesItem = useMemo(() => {
        let result = [] as any[]
        result.length = pages
        result.fill('', 0, pages)

        return result.map((el, i) => (
            <Pagination.Item
                key={i}
                active={i + 1 === selectedPage}
                onClick={() => setSelectedPage(i + 1)}
                href={makeLink(i + 1)}>
                {i + 1}
            </Pagination.Item>
        ))
    }, [pages, selectedPage, page, makeLink])

    useEffect(() => {
        setSelectedPage(page)
    }, [page])

    return (
        <Pagination>
            <Pagination.First
                href={makeLink(selectedPage - 1)}
                disabled={selectedPage === 1}
            />
            {pagesItem}
            <Pagination.Last
                href={makeLink(selectedPage + 1)}
                disabled={selectedPage === pages}
            />
        </Pagination>
    )
}

export default SearchPagination
